/*---------------
This script contains functions related PDP Grid. The grid shows related products attached to the main product via metafields. These scripts fetch the data from related products like price/quantity/variant ID etc and append it to the grid. The grid shows the variant size, price and available quantity. The gird allows the user to purchase the product only till the available qty.
-------*/

$(document).ready(function () {
  // add class for Safari Browser
  if (navigator.platform == 'MacIntel') {
    $('body').addClass('safari_browser');
  }

  /*---Fetching product IDs of related products-----*/

  var related_array_id = [];
  $('.related_pro_item').each(function (index) {
    related_array_id.push($(this).attr('data-product_id'));
  });

  /*-----------------------------------------------*/

  /*----Show loader icon while inventory is loading------*/

  setTimeout(function () {
    $('.inventory_loader').css('display', 'none');
    $('.mobile_table_wrapper.page-width').css('display', 'flex');
  }, 3000);

  /*-----------------------------------------------------*/

  /*------Find parent div with maximum number of available variants/sizes-------*/

  var maxCount = 0; //let max count be 0
  var parentWithMostChildren;

  //loop through parent div
  $('.related_pro_item').each(function () {
    //find and store child tree length
    var childCount = $(this).find('.meta_product_inventory').length;

    //if child count is greater than max count then let that be the new max count value
    if (childCount > maxCount) {
      maxCount = childCount;
      parentWithMostChildren = $(this);
    }
  });

  //the one parent with most childs will have a unique class
  if (parentWithMostChildren) {
    parentWithMostChildren.addClass('UniqueSizeDiv');
  }

  var dataProductHandle = ''; //this variable will be used to store the handle of unique product

  //use this unique div as a table header for sizes and prices

  //loop through the unique div child elements and fetch the price and size

  $('.UniqueSizeDiv .meta_product_inventory').each(function () {
    var variant_size = $(this).attr('data-variant_title');
    var variant_price = $(this).attr('data-variant_price');
    dataProductHandle = $('.UniqueSizeDiv').attr('data-product_handle');

    //append the price and size to the table header

    $('#variant_sizes_main').append(
      ' <div class="variant_detail_items" data-size="' +
        variant_size +
        '" data-title-variant="' +
        variant_size +
        '" data-price-variant="' +
        variant_price +
        '" data-parent-handle="dataProductHandle"><label class="size_opt_title">' +
        variant_size +
        '</label><span class="variant_price text-sm tableHeaderPrice-' +
        variant_size +
        '"></span></div>'
    );
  });

  /*--------------------------------------------------------------------------------------------------------------------*/

  /*-------Get real time prices from shopify for the unique selected product to show on the table header---------------------------*/

  updatePrices(dataProductHandle); //now we need to fetch prices from shopify

  //the function uses product URL to get real time prices from shopify backend. This makes sure we always get real time price for every catalog

  async function updatePrices(dataProductHandle) {
    if (dataProductHandle != '') {
      var getPricing = await fetch('/products/' + dataProductHandle + '.json')
        .then(response => response.json())
        .then(data =>
          $.each(data.product.variants, function (index, value) {
            $('.variant_detail_items').each(function (index) {
              var current = $(this).attr('data-size');
              if (value.title == current) {
                $(this)
                  .find('.variant_price')
                  .text('$ ' + value.price);
                $(this).attr('data-title-variant', value.title);
                $(this).attr('data-price-variant', value.price);
                $(this).attr('data-parent-handle', data.product.handle);
                var priceClass = '.data-variant-title-' + value.title;
                $(priceClass).attr('data-variant_price', value.price);
              }
            });
          })
        );
    }
  }

  sortSizes(dataProductHandle);

  /*------------------------------------------------------------------*/

  /*------Validate user quantity input with available quantity-------*/

  $(document).on('blur', '.variant_qty_input', function () {
    let final_total_row_qty = 0;

    let final_total_row_subTotal = 0;

    $('span.error_input_iventory.text-xs').css('display', 'none');

    $('.variant_qty_input').css('border-color', '#c6c6c6');

    $('.meta_product_inventory').removeClass('invokeErrorMessage');

    var userInput = $(this).val();

    const IsSameDayShipping = $(this).closest('.meta_product_inventory').attr('data_is_same_day');

    const directShipAvailableQty = $(this).closest('.meta_product_inventory').attr('data-variant_directship_qty');

    const casePackQty = $(this).closest('.meta_product_inventory').attr('data-variant_casepack_qty');

    const variantLocalQty = $(this).closest('.meta_product_inventory').attr('variantqty');

    if ($(this).closest('.meta_product_inventory').is('[data-variant_directship_qty]')) {
      $(this).closest('.meta_product_inventory').removeAttr('data-purchase');

      const userInput = Number($(this).val()) || 0; //validate input
      const directShipAvailableQty =
        Number($(this).closest('.meta_product_inventory').attr('data-variant_directship_qty')) || 0; //if directShip? else assign 0
      const variantLocalQty = Math.max(Number($(this).closest('.meta_product_inventory').attr('variantqty')) || 0, 0); //clamp negative to 0
      const casePackQty = Math.max(
        parseInt($(this).closest('.meta_product_inventory').attr('data-variant_casepack_qty'), 10) || 0,
        1
      ); //if case pack? else assign 1

      // Treat negative local qty as 0, already adjusted in direct ship
      const effectiveLocalQty = Math.max(variantLocalQty, 0);
      let totalAvailableQty = effectiveLocalQty + directShipAvailableQty;

      //validate if entered qty is greater than total available qty
      if (userInput > totalAvailableQty) {
        alert('The maximum amount available is ' + totalAvailableQty);
        if (directShipAvailableQty > 0) {
          const maxValidQty = Math.floor(totalAvailableQty / casePackQty) * casePackQty;
          $(this).val(maxValidQty);
          $(this).val(maxValidQty).trigger('input').trigger('change').trigger('focusout');
          $(this).closest('.meta_product_inventory').attr('data-purchase', 'DirectShip');
        } else {
          $(this).val(totalAvailableQty);
          $(this).val(totalAvailableQty).trigger('input').trigger('change').trigger('focusout');
          $(this).closest('.meta_product_inventory').attr('data-purchase', 'Local');
        }
      } else if (userInput % casePackQty > variantLocalQty && userInput > 0) {
        //check if entered qty module case pack is greater than localQty
        let adjustedQty = Math.ceil(userInput / casePackQty) * casePackQty;

        if (adjustedQty > totalAvailableQty) {
          adjustedQty = Math.floor(totalAvailableQty / casePackQty) * casePackQty;
        }

        if (casePackQty > 1) {
          alert(
            'The direct-shipment part of the order must be in case quantities of ' +
              casePackQty +
              '. Adjusting the quantity to the next valid size ' +
              adjustedQty
          );
        }

        if (userInput !== adjustedQty) {
          $(this).val(adjustedQty);
          $(this).val(adjustedQty).trigger('input'); // avoid change/focusout loop
        }

        if (adjustedQty <= variantLocalQty) {
          $(this).closest('.meta_product_inventory').attr('data-purchase', 'Local');
        } else {
          $(this).closest('.meta_product_inventory').attr('data-purchase', 'DirectShip');
        }

        $(this).addClass('cartItem');
        return;
      } else if (userInput > 0 && userInput <= Math.max(variantLocalQty, 0)) {
        $(this).closest('.meta_product_inventory').attr('data-purchase', 'Local');
        $(this).addClass('cartItem');
      } else if (userInput > 0 && userInput > Math.max(variantLocalQty, 0) && directShipAvailableQty > 0) {
        $(this).closest('.meta_product_inventory').attr('data-purchase', 'DirectShip');
        $(this).addClass('cartItem');
      } else if (userInput <= 0) {
        $(this).val('');
        $(this).removeClass('cartItem');
        $(this).closest('.meta_product_inventory').removeAttr('data-purchase');
      }
    } else {
      var qtyAvailable = $(this).attr('max');

      qtyAvailable = parseInt(qtyAvailable);

      if (userInput <= 0 || userInput > qtyAvailable || userInput == '' || userInput == 'undefined') {
        $(this).val('');

        $(this).removeClass('cartItem');

        $(this).closest('.meta_product_inventory').removeAttr('data-purchase');

        if (userInput != '') {
          $(this).closest('.meta_product_inventory').addClass('invokeErrorMessage');

          $('.invokeErrorMessage span.error_input_iventory').css('display', 'block');

          $('.invokeErrorMessage span.error_input_iventory').delay(3000).fadeOut(200);

          $(this).addClass('borderRed');
        }
      } else {
        $(this).addClass('cartItem');

        $(this).closest('.meta_product_inventory').attr('data-purchase', 'Local');
      }
    }

    var variant_parent_product_id = $(this).parents('.related_pro_item').attr('data-product_id');

    $('.related_pro_item').each(function (index) {
      var current_variant_id = $(this).attr('data-product_id');

      var current = $(this);

      if (variant_parent_product_id == current_variant_id) {
        var currentSubtotalValue = $(this).find('.location_alabma_subtotal .location_int_pricetotal').text();

        var currentQtyValue = $(this).find('.location_alabma_subtotal .location_int_subtotal').text();

        currentSubtotalValue = currentSubtotalValue.replace('$', '');

        currentSubtotalValue = parseFloat(currentSubtotalValue);

        currentQtyValue = parseInt(currentQtyValue);

        current.find('.meta_product_inventory').each(function (index) {
          var currentVariantQtyCheck = $(this);

          var currentUserInputValue = parseInt(currentVariantQtyCheck.find('.variant_qty_input').val());

          var currentVariantPrice = parseFloat(currentVariantQtyCheck.attr('data-variant_price'));

          var currentSubtotalPrice = currentUserInputValue * currentVariantPrice;

          if (isNaN(currentUserInputValue) != true) {
            final_total_row_qty += currentUserInputValue;

            final_total_row_subTotal += currentSubtotalPrice;

            current.find('.location_alabma_subtotal .location_int_subtotal').text(final_total_row_qty);

            current
              .find('.location_alabma_subtotal .location_int_pricetotal')
              .text(
                '$' +
                  new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
                    final_total_row_subTotal
                  )
              );
          }
        });
      }
    });

    var atLeastOneHasValue = false;

    $('.variant_qty_input').each(function () {
      if ($(this).val().trim() !== '') {
        atLeastOneHasValue = true;

        return false; // Break the loop if any input has a value
      }
    });

    if (atLeastOneHasValue) {
      $('.inventory_submit').removeClass('cart-disable');
    } else {
      $('.inventory_submit').addClass('cart-disable');
      // Do something when no input has a value
    }
  });

  /*----------------------------------------------------------------*/

  /*-------------------  Size sorting begins  -------------------*/

  //function receives unique product handle as a parameter
  function sortSizes(dataProductHandle) {
    // size hierarchy is defined and stored in a variable
    var sizeHierarchy = [
      '2XS',
      'XS',
      'S',
      'M',
      'L',
      'XL',
      '2XL',
      '3XL',
      '4XL',
      '5XL',
      '6XL',
      '7XL',
      '8XL',
      '9XL',
      '10XL',
      'OS',
      '2T',
      '3T',
      '4T'
    ];

    var product_sizes = []; //let product sizes be an array

    var unique_product_handle = dataProductHandle; //assign received parameter to a variable for clear understanding

    var product_id = ''; //let product id be empty

    //loop through whole grid to find size grid of unique product handle
    $('.related_pro_item').each(function () {
      var currentDataHandle = $(this).attr('data-product_handle');

      //if condition satisfy means the size grid of unique product is found and ready to be sorted
      if (currentDataHandle == unique_product_handle) {
        $(this)
          .find('.meta_product_inventory')
          .each(function () {
            var currentVariantSize = $(this).attr('data-variant_title');

            var currentVariantPrice = $(this).attr('data-variant_price');

            var currentSizePrice = currentVariantSize + ' : ' + currentVariantPrice;

            product_sizes.push(currentSizePrice);
          });

        return false;
      }
    });

    //sort the unique product size grid with size hierarchy
    product_sizes.sort(function (a, b) {
      return sizeHierarchy[a] - sizeHierarchy[b];
    });

    // call the mapSizes function to sort and map other products in the grid taking unique product now as a base
    mapSizes(product_sizes, unique_product_handle);
  }

  //map the sizes now with defined hierarchy of unique product handle
  function mapSizes(product_sizes, unique_product_handle) {
    var sizeHierarchy = [
      '2XS',
      'XS',
      'S',
      'M',
      'L',
      'XL',
      '2XL',
      '3XL',
      '4XL',
      '5XL',
      '6XL',
      '7XL',
      '8XL',
      '9XL',
      '10XL',
      'OS',
      '2T',
      '3T',
      '4T'
    ]; //size hierarchy is defined

    var uniqueProductSortedArray = product_sizes; //unique product in sorted form is received and stored

    var sizes = []; //let sizes be an array

    //loop through the whole grid to sort the size grid per product
    $('.related_pro_item').each(function () {
      var currentDataHandle = $(this).attr('data-product_handle'); //current handle of product in loop

      if (currentDataHandle) {
        sizes = [];

        var currentVariantSize = '';

        var currentVariantPrice = '';

        var currentVariantId = '';

        var currentVariantSku = '';

        var currentVariantQty = '';

        var currentVariantParentHandle = '';

        var currentVariantDirectShipQty = '';

        var currentVariantCasePackQty = '';

        var data_is_directShip_adjusted = '';

        //loop through size grid of current product in loop to get all values
        $(this)
          .find('.meta_product_inventory')
          .each(function () {
            // Store all values in variables
            const currentVariantSize = ($(this).attr('data-variant_title') || '').trim();
            const currentVariantPrice = ($(this).attr('data-variant_price') || '').trim();
            const currentVariantId = ($(this).attr('data-variant-id') || '').trim();
            const currentVariantSku = ($(this).attr('data-variant_sku') || '').trim();
            const currentVariantQty = ($(this).attr('variantqty') || '').trim();
            const currentVariantParentHandle = (currentDataHandle || '').trim();
            const currentVariantDirectShipQty = $(this).attr('data_variant_directShip_qty')?.trim() || '0';
            const currentVariantCasePackQty = (parseInt($(this).attr('data_variant_case_qty')?.trim(), 10) || 1).toString();
            const IsSameDayShipping = $(this).attr('data_is_same_day');
            const data_is_directShip_adjusted = $(this).attr('data_is_directShip_adjusted');
            const data_transit_days = $(this).attr('data_transit_days')?.trim() || '0';
            const data_is_directShip_enabled = $(this).attr('data_is_directShip_enabled');

            // Start constructing the currentSizePrice string
            let currentSizePrice = [
              currentVariantSize,
              currentVariantPrice,
              currentVariantId,
              currentVariantSku,
              currentVariantQty,
              currentVariantParentHandle,
              IsSameDayShipping,
              data_is_directShip_adjusted,
              data_transit_days,
              data_is_directShip_enabled
            ].join(' : ');

            // Append direct ship quantity if it's a valid number
            if (
              !isNaN(currentVariantDirectShipQty) &&
              currentVariantDirectShipQty !== '' &&
              currentVariantDirectShipQty !== null
            ) {
              currentSizePrice += ' : ' + currentVariantDirectShipQty;
            }

            // Append case pack quantity if it's a valid number
            if (!isNaN(currentVariantCasePackQty) && currentVariantCasePackQty !== '' && currentVariantCasePackQty !== null) {
              currentSizePrice += ' : ' + currentVariantCasePackQty;
            }

            // Push to array only if we have meaningful data
            if (currentSizePrice.trim() !== '') {
              sizes.push(currentSizePrice);
            }
          });

        //sort and map the created array sizes with unique product array
        var valueMap = {};

        //sizes array is splitted to retrieve the first value which is size of the current product (all sizes)
        $.each(sizes, function (index, value) {
          var parts = value.split(':');

          var sizeKey = parts[0].trim();

          valueMap[sizeKey] = value;
        });

        //mapping the sizes of current product in loop with unique product
        var sortedArray = $.map(uniqueProductSortedArray, function (keyValue) {
          var size = keyValue.split(':')[0].trim(); //split unique product array for size

          return valueMap[size] || size + ' : 0'; //map the size of current product in loop and return it sorted
        });

        var current = $(this); //store current product div in loop

        $(current).find('.qty_main_alabama').html(''); //find the inside html and make it empty so we can append it sorted

        //loop through the sorted array and assign the values accordingly
        $.each(sortedArray, function (key, sizes) {
          var splitValues = sizes.split(' : '); // Define splitValues correctly

          var variant_title = splitValues[0];

          var variant_price = splitValues[1];

          var variant_id = splitValues[2];

          var variant_sku = splitValues[3];

          var variant_qty = splitValues[4];

          var variant_handle = splitValues[5];

          var variant_isSameDayShipping = splitValues[6];

          var data_is_directShip_adjusted = splitValues[7];

          var data_transit_days = splitValues[8];

          var data_is_directShip_enabled = splitValues[9];

          // Only assign values if they exist and are valid numbers
          var variantDirectShipQty = splitValues[10] && !isNaN(splitValues[10]) ? splitValues[10] : null;
          var variantCasePackQty = splitValues[11] && !isNaN(splitValues[11]) ? splitValues[11] : null;

          // Create an object to store valid data attributes for finalHtml variable
          let attributes = {
            'data-variant-id': variant_id,
            'data-variant_title': variant_title,
            'data-variant_price': variant_price,
            'data-variant_sku': variant_sku,
            variantqty: variant_qty,
            data_parent_product_handle: variant_handle,
            data_is_same_day: variant_isSameDayShipping,
            data_is_directShip_adjusted: data_is_directShip_adjusted,
            data_transit_days: data_transit_days,
            data_is_directShip_enabled: data_is_directShip_enabled,
            'data-variant_directShip_qty': variantDirectShipQty,
            'data-variant_casePack_qty': variantCasePackQty
          };

          // Convert attributes object to a valid string for the HTML tag
          let attributesString = Object.entries(attributes)
            .map(([key, value]) => `${key}="${value}"`)
            .join(' ');

          var getTableHeaderSizePriceClass = 'tableHeaderPrice-' + variant_title; //unique class from table header price to compare

          var getTableHeaderSizePrice = $('.' + getTableHeaderSizePriceClass).text(); //get price of particular size from grid header

          var comparedPrice = 0; //let lowest price 0

          var matchedValue = null; //let matched price 0

          //loop through unique product array sizes to check if the price of current product sizes are lower
          $.each(uniqueProductSortedArray, function (index, element) {
            var splitElement = element.split(' : '); //split by colon

            var size = splitElement[0]; //get unique product current size in loop

            var value = splitElement[1]; //get unique product current size in loop price

            //if condition satisfy means the unique product and current product size matches
            if (size === variant_title) {
              matchedValue = value; //unique product current size in loop price

              if (matchedValue != null && variant_price > 0) {
                matchedValue = parseFloat(matchedValue);

                variantPrice = parseFloat(variant_price); //current product in loop size price

                //if current product size price is lower than unique product same size
                if (variantPrice != matchedValue) {
                  comparedPrice = variantPrice; //assign current product size price

                  return false; //break the loop
                }
              }
            }
          });

          //now we need to append the final sorted size grid for all products
          if (variant_qty > 0) {
            //if condition satisfy means current size has inventory and is available to purchase

            if (comparedPrice > 0) {
              //if condition satisfy means current size has lower price than unique product same size

              var finalHtml = '<div class="meta_product_inventory MACH2 gridRefreshed" ' + attributesString + '>';

              finalHtml +=
                '<label class="lowestVariantPrice"> $' +
                comparedPrice +
                '</label>' +
                '<div class="mobileOnlySizeLabel">' +
                variant_title +
                '</div>' +
                '<input class="variant_qty_input" type="number" max="' +
                variant_qty +
                '" min="1">' +
                '<span class="error_input_iventory text-xs">' +
                '<label class="max_error">Please add quantity less than ' +
                variant_qty +
                '</label></span>' +
                '<br><label class="variant_total_qty">' +
                variant_qty +
                '</label>';

              // Add DirectShip Qty label only if it has a valid value
              if (variantDirectShipQty > 0 && data_is_directShip_enabled == 'true') {
                finalHtml += '<label class="variant_directShip_Qty">' + variantDirectShipQty + '</label>';
              } else if (variantDirectShipQty <= 0 && data_is_directShip_enabled == 'true') {
                finalHtml += '<label class="variant_directShip_Qty"> - </label>';
              }

              // Add CasePack Qty label only if it has a valid value
              if (variantCasePackQty > 1 && data_is_directShip_enabled == 'true') {
                finalHtml += '<label class="variant_casePack_Qty">' + variantCasePackQty + '/case</label>';
              }

              finalHtml += '</div>';
            } else {
              var finalHtml = '<div class="meta_product_inventory MACH2 gridRefreshed" ' + attributesString + '>';

              finalHtml +=
                '<div class="mobileOnlySizeLabel">' +
                variant_title +
                '</div>' +
                '<input class="variant_qty_input" type="number" max="' +
                variant_qty +
                '" min="1">' +
                '<span class="error_input_iventory text-xs">' +
                '<label class="max_error">Please add quantity less than ' +
                variant_qty +
                '</label></span>' +
                '<br><label class="variant_total_qty">' +
                variant_qty +
                '</label>';

              // Add DirectShip Qty label only if it has a valid value
              if (variantDirectShipQty > 0 && data_is_directShip_enabled == 'true') {
                finalHtml += '<label class="variant_directShip_Qty">' + variantDirectShipQty + '</label>';
              } else if (variantDirectShipQty <= 0 && data_is_directShip_enabled == 'true') {
                finalHtml += '<label class="variant_directShip_Qty"> - </label>';
              }

              // Add CasePack Qty label only if it has a valid value
              if (variantCasePackQty > 1 && data_is_directShip_enabled == 'true') {
                finalHtml += '<label class="variant_casePack_Qty">' + variantCasePackQty + '/case</label>';
              }

              finalHtml += '</div></div>';
            }
          } else {
            if (comparedPrice > 0) {
              if (variantDirectShipQty && variantDirectShipQty > 0 && data_is_directShip_enabled == 'true') {
                var finalHtml =
                  '<div class="meta_product_inventory MACH2 gridRefreshed" ' +
                  attributesString +
                  '>' +
                  '<label class="lowestVariantPrice"> $' +
                  comparedPrice +
                  '</label>' +
                  '<div class="mobileOnlySizeLabel">' +
                  variant_title +
                  '</div>' +
                  '<input class="variant_qty_input" type="number" max="0" min="1">' +
                  '<span class="error_input_iventory text-xs">' +
                  '<label class="max_error">There is not sufficient quantity available</label></span>' +
                  '<br><label class="variant_total_qty"> - </label>';
              } else {
                var finalHtml =
                  '<div class="meta_product_inventory no-quantity MACH2 gridRefreshed" ' +
                  attributesString +
                  '>' +
                  '<label class="lowestVariantPrice"> $' +
                  comparedPrice +
                  '</label>' +
                  '<div class="mobileOnlySizeLabel">' +
                  variant_title +
                  '</div>' +
                  '<input class="variant_qty_input" type="number" max="0" min="1">' +
                  '<span class="error_input_iventory text-xs">' +
                  '<label class="max_error">There is not sufficient quantity available</label></span>' +
                  '<br><label class="variant_total_qty"> - </label>';
              }

              // Add DirectShip Qty label only if it has a valid value
              if (variantDirectShipQty > 0 && data_is_directShip_enabled == 'true') {
                finalHtml += '<label class="variant_directShip_Qty">' + variantDirectShipQty + '</label>';
              } else if (variantDirectShipQty <= 0 && data_is_directShip_enabled == 'true') {
                finalHtml += '<label class="variant_directShip_Qty"> - </label>';
              }

              // Add CasePack Qty label only if it has a valid value
              if (variantCasePackQty > 1 && data_is_directShip_enabled == 'true') {
                finalHtml += '<label class="variant_casePack_Qty">' + variantCasePackQty + '/case</label>';
              }

              finalHtml += '</div></div>'; // Close main divs
            } else {
              if (variantDirectShipQty && variantDirectShipQty > 0 && data_is_directShip_enabled == 'true') {
                var finalHtml =
                  '<div class="meta_product_inventory MACH2 gridRefreshed" ' +
                  attributesString +
                  '>' +
                  '<div class="mobileOnlySizeLabel">' +
                  variant_title +
                  '</div>' +
                  '<input class="variant_qty_input" type="number" max="0" min="1">' +
                  '<span class="error_input_iventory text-xs">' +
                  '<label class="max_error">There is not sufficient quantity available</label></span>' +
                  '<br><label class="variant_total_qty"> - </label>';
              } else {
                var finalHtml =
                  '<div class="meta_product_inventory no-quantity MACH2 gridRefreshed" ' +
                  attributesString +
                  '>' +
                  '<div class="mobileOnlySizeLabel">' +
                  variant_title +
                  '</div>' +
                  '<input class="variant_qty_input" type="number" max="0" min="1">' +
                  '<span class="error_input_iventory text-xs">' +
                  '<label class="max_error">There is not sufficient quantity available</label></span>' +
                  '<br><label class="variant_total_qty"> - </label>';
              }

              // Add DirectShip Qty label only if it has a valid value
              if (variantDirectShipQty > 0 && data_is_directShip_enabled == 'true') {
                finalHtml += '<label class="variant_directShip_Qty">' + variantDirectShipQty + '</label>';
              } else if (variantDirectShipQty <= 0 && data_is_directShip_enabled == 'true') {
                finalHtml += '<label class="variant_directShip_Qty"> - </label>';
              }

              // Add CasePack Qty label only if it has a valid value
              if (variantCasePackQty > 1 && data_is_directShip_enabled == 'true') {
                finalHtml += '<label class="variant_casePack_Qty">' + variantCasePackQty + '/case</label>';
              }

              finalHtml += '</div></div>'; // Close main divs
            }
          }

          //final size grid sorted html is appened for the current product in loop
          $(current).find('.qty_main_alabama').append(finalHtml);
        });
      }
    });
  }

  $('.variant_qty_input').keypress(function () {
    $('.inventory_submit').removeClass('cart-disable');
    $(this).removeClass('borderRed');
  });

  /*--------------------------------------------------------------------------*/

  /*---ATC EVENT START:- On ATC event data will be sent to cart via ajax------*/

  //on ATC click for both sticky and static button the ID and QTY is fetched from the grid via loop and sent to ajax cart function
  $('.inventory_submit').on('click', async function (e) {
    e.preventDefault(); // Prevent default form submission

    let items = [];
    let shippingTypes = new Set(); // Track unique shipping types (Local/DirectShip)

    let cartItems = $('input.variant_qty_input.cartItem'); // Select elements first

    console.log('Number of cart items:', cartItems.length);

    cartItems.each(function () {
      let metaInventory = $(this).closest('.meta_product_inventory');
      let Brand = $(this).closest('.related_pro_item').attr('data_brand');
      let variantID = metaInventory.attr('data-variant-id');
      let variantQTY = parseInt($(this).val(), 10) || 0; // Ensure valid number
      let purchaseType = metaInventory.attr('data-purchase');
      let variantTransitDays = metaInventory.attr('data_transit_days');
      let variantCaseQty = Math.max(parseInt(metaInventory.attr('data-variant_casepack_qty'), 10) || 0, 1);
      let variantLocalQty = Math.max(parseInt(metaInventory.attr('variantqty'), 10) || 0, 0);
      let variantDirectShipQty = parseInt(metaInventory.attr('data-variant_directship_qty'), 10) || 0;
      let cutOff = $(this).closest('.related_pro_item').attr('data_cutoff');

      if (variantQTY <= 0) {
        variantQTY = variantDirectShipQty; // Fallback to direct ship qty if needed
      }

      console.log(
        'Variant ID:',
        variantID,
        'Variant QTY:',
        variantQTY,
        'Purchase Type:',
        purchaseType,
        'Transit Days:',
        variantTransitDays
      );

      if (variantID && variantQTY > 0) {
        let itemData = {
          id: variantID,
          quantity: variantQTY
        };

        let itemProperties = {}; // Create an empty properties object

        //  Add properties only if they exist
        if (purchaseType === 'DirectShip' || purchaseType === 'Local') {
          itemProperties._shipping_type = purchaseType;
        }
        if (variantTransitDays && variantTransitDays !== 'null') {
          itemProperties._shipping_transit_time = variantTransitDays;
        }
        if (variantCaseQty) {
          itemProperties._itemCaseQty = variantCaseQty;
        }
        if (variantLocalQty) {
          itemProperties._local_qty = variantLocalQty;
        }
        if (variantDirectShipQty) {
          itemProperties._directship_qty = variantDirectShipQty;
        }
        if (Brand) {
          itemProperties._brand = Brand;
        }
        if (cutOff) {
          itemProperties._cutOff = cutOff;
        }

        //  Add properties object only if it has at least one valid property
        if (Object.keys(itemProperties).length > 0) {
          itemData.properties = itemProperties;
        }

        items.push(itemData);

        if (purchaseType) {
          shippingTypes.add(purchaseType);
        }
      }
    });

    // Check if `items` is still empty
    if (items.length === 0) {
      alert('No valid items to add to the cart. Please check your quantities.');
      return;
    }

    // Determine shipping type
    let shippingType = shippingTypes.size === 1 && shippingTypes.has('Local') ? 'Local' : 'MultiSourced';
    localStorage.setItem('shippingType', shippingType);

    console.log('Final Items:', items);
    console.log('Shipping Type:', shippingType);

    // **Send AJAX request using async/await**
    try {
      let response = await $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items }),
        contentType: 'application/json',
        dataType: 'json'
      });

      console.log('Items successfully added to cart!', response);
      location.reload(); // Reload the page after success
    } catch (error) {
      console.error('AJAX Error:', error);
      alert('Error adding items to cart: ' + (error.responseJSON?.description || 'Unknown error'));
    }
  });

  //function to hide the sticky ATC bar when clicked on hide anchor link

  $('.hideStickyBar').click(function () {
    $('.Atc_Wrapper.addToCartSticky').hide();
  });

  //on ATC click the loader will be displayed as a part of UX
  $('.loadingButton').on('click', function () {
    var $btn = $(this);

    // Add spinner and set loading state
    $btn.addClass('loading');

    $btn.prepend('<div class="spinnerX"></div>');

    // Simulate a delay (e.g., for an AJAX request)
    setTimeout(function () {
      // Remove spinner and loading state
      $btn.removeClass('loading');

      $btn.find('.spinnerX').remove();
    }, 3000); // Adjust the delay as needed
  });

  /*---ATC EVENT ENDS:- On ATC event data will be sent to cart via ajax------*/

  //clicking inside any input on the grid will hide existing errors
  $(document).on('click', '.variant_qty_input', function () {
    $('.error_input_iventory').hide();
    $('.variant_qty_input').removeClass('borderRed');
  });

  /*-------PDP Dropdown Options----------------------------*/

  //PDP swatch dropdown

  $('#allColors label').click(function () {
    $('#colorDropdown').toggle();
  });

  // Hide color dropdown when click outside
  var targetDiv = $('#allColors');

  // Attach a click event listener to the document body
  $(document).on('click', function (event) {
    // Check if the click event target is not the target div or its descendants
    if (!targetDiv.is(event.target) && targetDiv.has(event.target).length === 0) {
      // If clicked outside of the target div, hide the div
      $('#colorDropdown').hide();
    }
  });

  $(document).ready(function () {
    var swatch_color_name = $('.product-detail__title').attr('data-color');
    $('.selected_color_swatch').html(swatch_color_name);
    $('.Product_swatch_colors .swatch-option').first().addClass('active-color');
  });

  $('#colorDropdown input').click(function () {
    if ($('#colorDropdown_options input:checked').length == 0) {
      $('.selected_colors').html('All Colors');
      $('#resetGrid').addClass('is-disabled');
    } else {
      $('.selected_colors').html($('#colorDropdown_options input:checked').length + ' color(s) selected');
      $('#resetGrid').removeClass('is-disabled');
    }

    if ($('#colorDropdown_options input:checked').length == $('#colorDropdown_options input').length) {
      $("#selectAll input[type='checkbox']").prop('checked', true);
    } else {
      $("#selectAll input[type='checkbox']").prop('checked', false);
    }

    if ($('#colorDropdown_options input:checked').length < 1) {
      if ($('#sameDayCheckbox').prop('checked') == true) {
        $(".related_pro_item[data_islocallystocked='true']").show();
        $(".related_pro_item[data_islocallystocked='false']").hide();
      } else {
        $('.related_pro_item').show();
        $('.related_pro_item:first-child').removeClass('single_related');
      }
    } else {
      $('.related_pro_item').hide();
      if ($('#colorDropdown_options input:checked:checked').length == 1) {
        $('.related_pro_item:first-child').addClass('single_related');
      } else {
        $('.related_pro_item:first-child').removeClass('single_related');
      }
      $('ul#colorDropdown input:checkbox:checked').each(function () {
        var product_handle_color = $(this).parents('li').attr('data-product_handle');
        $('.related_pro_item').each(function (index) {
          var product_handle_rel_item = $(this).attr('data-product_handle');
          var current_related = $(this);
          if (product_handle_color == product_handle_rel_item) {
            current_related.css('display', 'flex');
          }
        });
      });
    }
  });

  // Clear All button click event
  $('#clearAll').click(function () {
    if ($('#sameDayCheckbox').prop('checked') == true) {
      $(".related_pro_item[data_islocallystocked='true']").show();

      $(".related_pro_item[data_islocallystocked='false']").hide();

      $("#colorDropdown input[type='checkbox']").prop('checked', false);

      $('.selected_colors').html('All Colors');

      $('.swatch-option').removeClass('active-color');

      $('#resetGrid').addClass('is-disabled');
    } else {
      $('.related_pro_item').show();

      $("#colorDropdown input[type='checkbox']").prop('checked', false);

      $('.selected_colors').html('All Colors');

      $('.swatch-option').removeClass('active-color');

      $('#resetGrid').addClass('is-disabled');
    }
  });

  // Clear grid button click event
  $('#resetGrid').click(function () {
    if ($('#sameDayCheckbox').prop('checked') == true) {
      $(".related_pro_item[data_islocallystocked='true']").show();

      $(".related_pro_item[data_islocallystocked='false']").hide();

      $("#colorDropdown input[type='checkbox']").prop('checked', false);

      $('.selected_colors').html('All Colors');

      $('.swatch-option').removeClass('active-color');

      $('#resetGrid').addClass('is-disabled');
    } else {
      $('.related_pro_item').show();

      $("#colorDropdown input[type='checkbox']").prop('checked', false);

      $('.selected_colors').html('All Colors');

      $('.swatch-option').removeClass('active-color');

      $('#resetGrid').addClass('is-disabled');
    }
  });

  // Select All button click event
  $('#selectAll').click(function () {
    if ($('#sameDayCheckbox').prop('checked') == true) {
      $(".related_pro_item[data_islocallystocked='true']").show();

      $(".related_pro_item[data_islocallystocked='false']").hide();

      if ($("#selectAll input[type='checkbox']").prop('checked') == false) {
        $('#colorDropdown_options li').each(function (index) {
          if ($(this).css('display') != 'none') {
            $(this).find("input[type='checkbox']").prop('checked', true);

            $("#selectAll input[type='checkbox']").prop('checked', true);
          }
        });

        $('.selected_colors').html($('#colorDropdown_options input:checked').length + ' color(s) selected');
      } else {
        $('#colorDropdown_options li').each(function (index) {
          if ($(this).css('display') != 'none') {
            $(this).find("input[type='checkbox']").prop('checked', false);

            $("#selectAll input[type='checkbox']").prop('checked', false);
          }
        });

        $('.selected_colors').html('All Colors');
      }
    } else {
      $('.high_stock').prop('checked', false);

      $('.related_pro_item').show();

      if ($('#colorDropdown_options input:checked').length == $('#colorDropdown_options input').length) {
        //do something

        $("#colorDropdown_options input[type='checkbox']").prop('checked', false);

        $("#selectAll input[type='checkbox']").prop('checked', false);
      } else {
        $("#colorDropdown_options input[type='checkbox']").prop('checked', true);

        $('.selected_colors').html('All Colors');

        $("#selectAll input[type='checkbox']").prop('checked', true);
      }
    }
  });

  //change PDP image on swatch click

  $(document).ready(function () {
    var swatch_color_name = $('.product-info__title').attr('data-color');
    $('.selected_color_swatch').html(swatch_color_name);
    $('.Product_swatch_colors .swatch-option').first().addClass('active-color');
  });

  $(document).on('click', '.Product_swatch_colors .swatch-option', function () {
    var product_handle_selected = $(this).attr('data-product_handle');
    var swatch_color_name = $(this).find('.swatch-option_name').attr('data-color');
    $('.selected_color_swatch').html(swatch_color_name);

    // ALWAYS remove active-color from ALL swatches first (prevents multiple selections)
    $('.Product_swatch_colors .swatch-option').removeClass('active-color');
    
    // Add active-color to the clicked swatch
    $(this).addClass('active-color');

    $.ajax({
      type: 'GET',
      url: '/products/' + product_handle_selected + '?section=main-product',
      success: function (data) {
        var gallery_content = $(data).find('.product-layout-grid__images').html();
        var product_zoom_image = $(data).find('.pswp__scroll-wrap').html();
        
        // Update gallery and zoom (but NOT the product detail which contains swatches)
        $('.product-layout-grid__images').html(gallery_content);
        $('.pswp__scroll-wrap').html(product_zoom_image);
        
        // Initialize slick carousel for new images
        $('.product-detail__images').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1
        });
        
        // Update product title color attribute if needed
        var newColorAttr = $(data).find('.product-detail__title').attr('data-color');
        if (newColorAttr) {
          $('.product-detail__title').attr('data-color', newColorAttr);
        }
      },
      error: function (error) {
        console.error('Error fetching section content:', error);
      }
    });

    // No need to call observeSwatchSelection() since we're not rebuilding swatches
  });

  $(document).on('click', '.option-selector .cc-select__option.js-option', function () {
    var variant_value = $(this).attr('data-value');
    var product_handle_selected = '';
    var variant_id = '';
    $('select[name="id"] option').each(function () {
      var option_title = $(this).text();
      if (variant_value == option_title) {
        variant_id = $(this).attr('value');
        return false;
      }
    });

    $('.swatch-option').each(function () {
      if ($(this).hasClass('active-color')) {
        product_handle_selected = $(this).attr('data-product_handle');
      }
    });

    $.ajax({
      type: 'GET',
      url: '/products/' + product_handle_selected + '?variant=' + variant_id,
      success: function (data) {
        var product_detail = $(data).find('.product-detail__detail').html();
        // Append the fetched content to the container
        $('.product-detail__detail').html(product_detail);
      },
      error: function (error) {
        console.error('Error fetching section content:', error);
      }
    });
  });

  $(document).on('click', '.product-detail__thumbnail', function () {
    $('.product-detail__thumbnail').removeClass('thumb-active');
    var thumbnail_url = $(this).attr('href');
    $(this).addClass('thumb-active');
    $('.product-media .rimage-outer-wrapper .rimage-wrapper:first-child img').attr('src', thumbnail_url);
    $('.product-media .rimage-outer-wrapper .rimage-wrapper:first-child img').attr('srcset', thumbnail_url);
  });

  function validate() {
    var flag = false;

    $('.swatch-option').each(function () {
      if ($(this).hasClass('active-color')) {
        flag = true;
      }
    });

    if (flag === false) {
      $('.related_pro_item').show();
      $("#colorDropdown input[type='checkbox']").prop('checked', false);
      $('.selected_colors').html('All Colors');
      $('.swatch-option').removeClass('active-color');
      $('#resetGrid').addClass('is-disabled');
    }
  }

  function observeSwatchSelection() {
    $('input[type="checkbox"]').prop('checked', false);

    var i = 0;

    $('.swatch-option').each(function () {
      if ($(this).hasClass('active-color')) {
        var i = 1;

        var selectedSwatch = $(this).attr('data-swatch-name');

        var colorDropDownText = $(this).attr('data-dopdown-swatch-name');

        $('.colorDropdownCheckbox[data-color-name="' + selectedSwatch + '"]').click();

        if ($('#colorDropdown_options input:checked').length == 0) {
          $('.selected_colors').text(colorDropDownText);
          $('#resetGrid').addClass('is-disabled');
        } else {
          $('.selected_colors').html($('#colorDropdown_options input:checked').length + ' color(s) selected');
          $('#resetGrid').removeClass('is-disabled');
        }
      }
    });

    validate();
  }

  function mapSelectedDropdown() {
    // Loop through each checkbox in the colorDropdown_options div
    $('#colorDropdown_options input[type="checkbox"]').each(function () {
      // Check if the checkbox is checked
      if ($(this).is(':checked')) {
        // Get the data-product_handle from the parent li
        var productHandle = $(this).closest('li').attr('data-product_handle');

        // Loop through the div elements with class swatch-option
        $('.swatch-option').each(function () {
          // Find the element with matching data-product_handle
          if ($(this).attr('data-product_handle') === productHandle) {
            // Toggle the 'active' class
            $(this).addClass('active-color');
            return false;
          }
        });
      } else {
        var productHandle = $(this).closest('li').attr('data-product_handle');
        $('.swatch-option').each(function () {
          // Find the element with matching data-product_handle
          if ($(this).attr('data-product_handle') === productHandle) {
            // Toggle the 'active' class
            $(this).removeClass('active-color');
            return false;
          }
        });
      }
    });
  }

  /*--------------------------------------------------------*/

  // Only run this function when a user manually clicks the checkbox
  $('#colorDropdown_options input[type="checkbox"]').on('click', function (event) {
    if (!event.isTrigger) {
      setTimeout(function () {
        mapSelectedDropdown();
      }, 2000);
      // Only execute if the event is not triggered programmatically
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var local_checkbox = 'false';
  var IsSameDayShipping = $('.related_pro_item.mainColorProduct').attr('data_ischeckbox_visible');
  if (IsSameDayShipping == 'true') {
    local_checkbox = 'true';
  }
  if (local_checkbox == 'false') {
    $('.same_day_available').css('display', 'none');
  }

  let checkbox = document.getElementById('sameDayCheckbox');
  let colorArr = [];
  if (checkbox) {
    checkbox.addEventListener('change', function () {
      console.log('checkbox clicked');
      let isChecked = this.checked;
      document.querySelectorAll('.related_pro_item').forEach(function (parent, index) {
        let isSameDay = parent.getAttribute('data_islocallystocked') === 'true';
        // Hide parent only if checkbox is checked and it's not same-day
        parent.style.display = isChecked && !isSameDay ? 'none' : '';
        if (isSameDay) {
          let colorName = parent.getAttribute('data-inventory-color');
          colorArr[index] = colorName;
        }
      });
      $('#colorDropdown_options li').find("input[type='checkbox']").prop('checked', false);
      $('.selected_colors').html('All Colors');

      if (isChecked) {
        $("#selectAll input[type='checkbox']").prop('checked', true);
        $('.variant_directShip_qty_label').hide();
        $('.variant_casePack_qty_label').hide();
        $('.variant_directShip_Qty').hide();
        $('.variant_casePack_Qty').hide();
      } else {
        $("#selectAll input[type='checkbox']").prop('checked', false);
        $('.variant_directShip_qty_label').show();
        $('.variant_casePack_qty_label').show();
        $('.variant_directShip_Qty').show();
        $('.variant_casePack_Qty').show();
      }
      document.querySelectorAll('#colorDropdown_options li').forEach(function (parent) {
        let colorName = parent.getAttribute('data-color');
        let isColorTrue = colorArr.indexOf(colorName) > -1;
        parent.style.display = isChecked && !isColorTrue ? 'none' : '';
        if (isChecked && isColorTrue) {
          parent.children[0].checked = true;
        }
      });

      document.querySelectorAll('.swatch-option').forEach(function (parent) {
        let colorSwatch = parent.getAttribute('data-swatch-name');
        let isColorTrue = colorArr.indexOf(colorSwatch) > -1;

        if (isChecked && isColorTrue) {
          parent.classList.add('active-color');
        } else {
          parent.classList.remove('active-color');
        }
      });
    });
  }
});
